module.exports = __webpack_public_path__ + "0317ac5713d7ce20d5fca08081af86b0.png";